import React from "react";

/**
 * Bootstrap column. Accepts size props: xs, sm, md, lg, xl.
 * Each can be a number (col-lg-6) or an object { size, offset } (col-lg-6 offset-lg-2).
 * Also accepts `tag` to render as a different element (e.g. "aside").
 */
const BREAKPOINTS = ["xs", "sm", "md", "lg", "xl"];

function buildColClasses(props) {
  const classes = [];
  for (const bp of BREAKPOINTS) {
    const val = props[bp];
    if (val == null) continue;
    if (typeof val === "number" || typeof val === "string") {
      classes.push(bp === "xs" ? `col-${val}` : `col-${bp}-${val}`);
    } else if (typeof val === "object") {
      if (val.size != null) classes.push(bp === "xs" ? `col-${val.size}` : `col-${bp}-${val.size}`);
      if (val.offset != null) classes.push(`offset-${bp}-${val.offset}`);
    }
  }
  // If no breakpoint props, render a plain "col"
  return classes.length ? classes : ["col"];
}

const Col = ({ tag: Tag = "div", className = "", style, children, ...rest }) => {
  const colClasses = buildColClasses(rest);

  // Strip breakpoint keys from rest so they don't land on the DOM element
  const domProps = Object.fromEntries(
    Object.entries(rest).filter(([k]) => !BREAKPOINTS.includes(k))
  );

  const cls = [...colClasses, className].filter(Boolean).join(" ");

  return (
    <Tag className={cls} style={style} {...domProps}>
      {children}
    </Tag>
  );
};

export default Col;
